import { FC } from 'react'

const Dashboard: FC = () => {
  return <h2>Dashboard</h2>
}

export default Dashboard;